export type RightBarFallbackItem = {
  tagdata: any[];
  bestoftheday: any[];
  bestoftheweek: any[];
  bestofthemonth: any[];
  banner: any[];
};

export const getEmptyRightBarData = (): RightBarFallbackItem[] => [
  {
    tagdata: [],
    bestoftheday: [],
    bestoftheweek: [],
    bestofthemonth: [],
    banner: [],
  },
];
